// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1W7BN","type":"styles_type__2PAyi","choices":"styles_choices__1BTa4"};